export const App = {
  Linkfluence: "linkfluence",
  Radarly: "radarly",
  Search: "linkfluence_search",
  Hootsuite: "hootsuite",
  RadarlyBO: "radarly_bo",
  RadarlySettings: "radarly_settings",
  RadarlySettingsOld: "radarly_settings_old",
  SocialWall: "social_wall",
  Tribes: "kol",
  Visa: "visa",
  InsightPages: "insight_pages",
  Klear: "klear",
  MediaRelations: "media_relations",
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type App = typeof App[keyof typeof App];
